import React from 'react';

import { Button } from '@mui/material';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import KeyboardArrowLeftRoundedIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import TableRowsRoundedIcon from '@mui/icons-material/TableRowsRounded';

import { COLOR_PRIMARY_2 } from 'src/utils/colors';

const ShowFullTableButton = ({
  showFullTable,
  setShowFullTable,
}: {
  showFullTable: boolean;
  setShowFullTable: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Button
      onClick={() => setShowFullTable(!showFullTable)}
      variant="outlined"
      size="small"
      sx={{
        color: COLOR_PRIMARY_2,
        borderColor: COLOR_PRIMARY_2,
        '&:hover': {
          backgroundColor: COLOR_PRIMARY_2,
          color: 'white',
        },
      }}
    >
      {showFullTable ? (
        <MapRoundedIcon sx={{ mr: 1 }} />
      ) : (
        <TableRowsRoundedIcon sx={{ mr: 1 }} />
      )}{' '}
      {showFullTable ? 'Show Map' : 'Full Table'}{' '}
      {showFullTable ? <KeyboardArrowLeftRoundedIcon /> : <KeyboardArrowRightRoundedIcon />}
    </Button>
  );
};

export default ShowFullTableButton;
